import { useDeviceModeContext } from 'client/context/DeviceModeContext'
import MenuInterface from 'common/components/entities/Menu/types/MenuInterface'
import React from 'react'
import { CheckboxControl } from 'src/editor/shared/settings/checkbox-control'
import { ColorPickerControl } from 'src/editor/shared/settings/controls/color-picker/color-picker-control'

type BurgerProps = {
  isShowCheckbox?: boolean
  update: <K extends keyof MenuInterface>(
    prop: K,
  ) => (value: MenuInterface[K]) => void
  entity: MenuInterface
}
const MenuBurger = ({ update, entity, isShowCheckbox = true }: BurgerProps) => {
  const { isMobile } = useDeviceModeContext()
  return isMobile ? (
    <>
      {isShowCheckbox && (
        <CheckboxControl
          label="entity_settings.menu.item.show_burger_on_mobile"
          update={update('burger')}
          value={entity.burger}
        />
      )}
      {entity.burger && (
        <ColorPickerControl
          update={update('burgerIconColor')}
          color={entity.burgerIconColor}
          label="entity_settings.menu.item.burger_color"
          singleColorMode
        />
      )}
    </>
  ) : (
    <></>
  )
}

export default MenuBurger
